import { render, staticRenderFns } from "./pivotDataTable.vue?vue&type=template&id=150fc5b4&"
import script from "./pivotDataTable.vue?vue&type=script&lang=js&"
export * from "./pivotDataTable.vue?vue&type=script&lang=js&"
import style0 from "./pivotDataTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports